<template>
  <div class="bg-gray-700 rounded-lg p-4 mb-6 shadow-inner">
    <div class="flex justify-between items-start mb-2">
      <h3 class="text-blue-400 font-semibold">Prodavac</h3>
      <button
        v-if="!isCurrentUserProductOwner"
        @click="handleReportClick"
        class="text-gray-400 hover:text-red-400 transition-colors text-sm flex items-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 mr-1"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M11 17h1m0 0h1m-1 0v-4m8-6-8-4-8 4m16 0v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7m14-2v10"
          />
        </svg>
        Prijavi
      </button>
    </div>
    <router-link
      :to="{
        name: 'profile',
        params: { id: product.user.id },
      }"
      class="flex items-center hover:bg-gray-600 p-2 rounded-md transition-colors"
    >
      <div
        class="bg-gray-900 rounded-full w-10 h-10 flex items-center justify-center mr-3 shadow-md"
      >
        <span class="text-blue-400 font-bold">{{
          product.user.username.charAt(0).toUpperCase()
        }}</span>
      </div>
      <div>
        <p class="text-blue-400 font-medium">
          {{ product.user.username }}
        </p>
        <p class="text-blue-400 text-sm">{{ product.user.city }}</p>
      </div>
    </router-link>
    <div class="mt-2 flex items-center">
      <div class="flex items-center mr-4">
        <span class="text-green-400 mr-1"
          >+{{ product.user.positiveRatings }}</span
        >
        <span class="text-gray-400">pozitivnih</span>
      </div>
      <div class="flex items-center">
        <span class="text-red-400 mr-1"
          >-{{ product.user.negativeRatings }}</span
        >
        <span class="text-gray-400">negativnih</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, onMounted } from 'vue';
import { Product } from '@/composables/useProductDetail';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'ProductSellerInfo',
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    isCurrentUserProductOwner: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['open-report-modal', 'show-login-required-toast'],
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();

    // Učitaj korisnika kad se komponenta mountuje ako postoji token
    onMounted(async () => {
      if (localStorage.getItem('token') && !store.state.auth.user) {
        try {
          await store.dispatch('auth/fetchCurrentUser');
          console.log('User fetched on mount:', store.state.auth.user);
        } catch (error) {
          console.error('Error fetching user on mount:', error);
        }
      }
    });

    const handleReportClick = () => {
      // Direktno proveravamo na osnovu tokena i korisnika
      const hasToken = !!localStorage.getItem('token');
      const hasUser = !!store.state.auth.user;

      console.log('Report click - token exists:', hasToken);
      console.log('Report click - user exists:', hasUser);

      if (!hasToken) {
        // Nema tokena, korisnik nije ulogovan
        emit(
          'show-login-required-toast',
          'Morate biti prijavljeni da biste prijavili korisnika.'
        );
        localStorage.setItem('redirectAfterLogin', window.location.pathname);
        setTimeout(() => {
          router.push('/login');
        }, 1500);
        return;
      }

      // Ako token postoji ali nema korisnika, pokušaj ponovo dohvatiti korisnika
      if (hasToken && !hasUser) {
        store
          .dispatch('auth/fetchCurrentUser')
          .then(() => {
            console.log('User fetched successfully:', store.state.auth.user);
            // Ovde otvaramo modal
            emit('open-report-modal');
          })
          .catch((error) => {
            console.error('Failed to fetch user:', error);
            // Još uvek otvaramo modal, jer imamo token
            emit('open-report-modal');
          });
        return;
      }

      // Imamo i token i korisnika, otvaramo modal direktno
      emit('open-report-modal');
    };

    return {
      handleReportClick,
    };
  },
});
</script>
